module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-in-scene"
  }, [_vm._v("Q")]), _vm._v("uattro auto sportive passarono davanti al grande cartellone che dava il benvenuto nella città del peccato e, come ogni anno, si fermarono di fronte alla porta del maestoso hotel Bellagio. Las Vegas Boulevard brulicava di gente che transitava a piedi. Persone che uscivano da un hotel per entrare nel seguente, tutti avevano macchine fotografiche in mano, pronte per scattare foto o, per meglio dire, per immortalare le vacanze in quella città. Cosa che era un po' sciocca, pensava Ralph mentre scendeva dalla sua Lamborghini Murcielago verde. Gli era sempre sembrato assurdo che i turisti usassero con tanta convinzione il famoso modo di dire \"Quello che succede a Las Vegas resta a Las Vegas\" e poi saltassero fuori certe fotografie compromettenti che loro stessi, in un momento di ubriachezza, avevano scattato.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Era ogni anno la stessa storia, e sorrise al pensiero. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Stai già sorridendo per le avventure che avrai questo fine settimana?» gli chiese Mike mentre porgeva le chiavi della sua Porsche Carrera GT indaco a un parcheggiatore. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Puoi dirlo forte, fratello!» rispose Ralph, e subito dopo il suo sorriso si ampliò. «Sul serio, Mike, stavo pensando a tutti quelli che vanno in ferie e gridano ai quattro venti \"Quello che succede a Las Vegas resta a Las Vegas\" e poi, stupidi come sono, implorano il cielo che la moglie, la fidanzata o quello che hanno, non veda le foto che i loro amici pubblicano su quel social network conosciutissimo»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Facebook» rispose Gabriel avvicinandosi a loro. «Dovresti veramente metterti al passo con la tecnologia, anche solo per usarla una volta l'anno»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Bah!» sbottò Ralph «Non ho bisogno di perdere tempo davanti a uno schermo a farmi i fatti degli altri» rispose a Gabriel «Spero che le avventure di quest'anno siano migliori di quelle dell'anno scorso»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Anche io lo spero» aggiunse Uryan mentre si univa ai suoi compagni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Bene, basta chiacchiere davanti alla porta dell'hotel, iniziamo a sembrare vecchie comari. Entriamo»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Una volta dentro l'hotel, il quartetto si diresse verso la reception, si registrò e, dopo avere fatto uno spuntino, uscì a ispezionare l'area e l'ambiente. Non che non lo conoscessero, tutti gli anni tornavano nello stesso posto, ma non tutti gli anni si percepiva la stessa cosa. Ogni anno che passava sentivano cose nuove nell'ambiente: più lusso, più vizi, più pazzie. Ovviamente non è che desse loro fastidio, anzi, si divertivano e ricaricavano le batterie per poi tornare al lavoro e risolvere i problemi del prossimo. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Era un po' difficile che quei quattro gentiluomini non suscitassero i sospiri delle femmine quando passavano vicini a loro. Erano incredibilmente attraenti. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mike aveva un corpo da guerriero, i suoi muscoli risaltavano a ogni movimento, i suoi occhi di colore indaco erano perfettamente contornati da spesse ciglia biondo cenere, lo stesso colore dei suoi capelli. Gabriel aveva una pelle molto bianca, sembrava porcellana, i capelli lisci e di colore castano gli arrivavano alle spalle e gli occhi grigio chiaro spiazzavano qualsiasi donna. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ralph era un po' più magro di Mike, aveva la pelle cannella, i capelli biondi e gli occhi verdi con sottili striature gialle. E Uryan era l'unico al mondo coi capelli rossi a non avere nemmeno una lentiggine sulla pelle, con muscoli ben definiti come quelli di Mike, aveva gli occhi color ambra e un sorriso da copertina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Erano d'accordo di andare in un locale alla moda ad ascoltare buona musica e, se la sorte gli sorrideva, a rimorchiare qualcuno. Ma Mike aveva in mente altro.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Andate voi al locale» disse loro Mike. «Io preferisco andare a vedere come mi va al casinò, quest'anno dovrebbe andarmi un po' meglio»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ralph lo osservò con uno sguardo inquisitore.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Gioca con cautela, ok?» gli disse. «Non voglio vederti piagnucolare in giro perché hai perso più del dovuto»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mike sorrise.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a49d504e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0